<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">

        <!-- 状态区 -->
        <a-row :gutter="24" style="margin-bottom: 16px">
          <a-col :md="8" :sm="24">
            <a-statistic title="训练状态" :value="stateText">
            </a-statistic>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-statistic title="进度" :value="statusInfo.progress || 0" suffix="%">
            </a-statistic>
          </a-col>
          <a-col :md="8" :sm="24" style="text-align: right">
            <a-button v-if="btnEnableList.indexOf(1)>-1 && statusInfo.state !== 'running'"
              type="primary" icon="play-circle" :loading="actionLoading" @click="handleStart">启动训练</a-button>
            <a-button v-if="btnEnableList.indexOf(1)>-1 && statusInfo.state === 'running'"
              type="danger" icon="pause-circle" :loading="actionLoading" @click="handleStop">停止训练</a-button>
          </a-col>
        </a-row>

        <a-progress v-if="statusInfo.state === 'running'" :percent="statusInfo.progress || 0"
          style="margin-bottom: 16px" />

        <a-divider />

        <!-- 最近日志 -->
        <a-form :labelCol="{ span: 4 }" :wrapperCol="{ span: 19 }">
          <a-form-item label="最近日志">
            <pre class="train-log">{{ statusInfo.log || '暂无日志' }}</pre>
          </a-form-item>
          <a-form-item label="数据集目录">
            <span style="font-family: monospace">service/dataset/images（原图） + service/dataset/labels（同名.json：4角点坐标）</span>
          </a-form-item>
          <a-form-item label="数据集状态">
            <a-tag :color="statusInfo.datasetReady ? 'green' : 'orange'">
              {{ statusInfo.datasetReady ? '已就绪' : '未就绪' }}
            </a-tag>
          </a-form-item>
        </a-form>

        <a-alert
          type="info"
          showIcon
          style="margin-top: 8px"
          message="训练说明"
          description="训练进程与推理进程相互隔离，训练期间对外角点检测接口继续使用旧模型不受影响。训练完成后需确认替换，新模型写入 service/models/ 生效，旧模型自动备份为 *.bak 支持一键回滚。数据集无需区分证件类型，所有证件混合训练。" />

        <a-button style="margin-top: 16px" icon="reload" @click="loadStatus">刷新状态</a-button>

      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import Vue from 'vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { startTraining, stopTraining, getTrainingStatus } from '@/api/plugin/certCrop'

const STATE_TEXT = {
  idle: '空闲',
  running: '训练中',
  failed: '失败',
  done: '已完成'
}

export default {
  name: 'Training',
  mixins: [JeecgListMixin],
  data() {
    return {
      // 必须与 jsh_function.url 一致，按钮显隐依赖该字段
      urlPath: '/plugin/cert-crop/training',
      statusInfo: { state: 'idle', progress: 0, datasetReady: false, log: '' },
      actionLoading: false,
      pollTimer: null
    }
  },
  computed: {
    stateText() {
      return STATE_TEXT[this.statusInfo.state] || this.statusInfo.state || '-'
    }
  },
  mounted() {
    this.loadStatus()
    this.startPoll()
  },
  beforeDestroy() {
    this.stopPoll()
  },
  methods: {
    // 覆盖mixin：训练页无列表数据，占位避免mixin loadData读this.url.list抛TypeError中断created
    loadData() {},
    // 覆盖mixin：超管admin框架不返回userBtn，未匹配到权限数据时默认放开（与TemplateList口径一致）
    initActiveBtnStr() {
      let btnStrList = Vue.ls.get('winBtnStrList')
      if (btnStrList && btnStrList.length > 0) {
        for (let i = 0; i < btnStrList.length; i++) {
          if (btnStrList[i].url === this.urlPath && btnStrList[i].btnStr) {
            this.btnEnableList = btnStrList[i].btnStr
            return
          }
        }
      }
      this.btnEnableList = '1'
    },
    loadStatus() {
      getTrainingStatus().then((res) => {
        if (res.code === 200 && res.data) {
          this.statusInfo = res.data
        } else if (res.code !== 200) {
          this.$message.warning(res.msg || '获取训练状态失败')
        }
      })
    },
    startPoll() {
      this.stopPoll()
      this.pollTimer = setInterval(() => {
        if (this.statusInfo.state === 'running') {
          this.loadStatus()
        }
      }, 5000)
    },
    stopPoll() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    handleStart() {
      this.actionLoading = true
      startTraining().then((res) => {
        this.actionLoading = false
        if (res.code === 200) {
          this.$message.success(res.msg || '训练已启动')
        } else {
          this.$message.warning(res.msg || '启动失败')
        }
        this.loadStatus()
      }).catch(() => { this.actionLoading = false })
    },
    handleStop() {
      this.actionLoading = true
      stopTraining().then((res) => {
        this.actionLoading = false
        if (res.code === 200) {
          this.$message.success(res.msg || '训练已停止')
        } else {
          this.$message.warning(res.msg || '停止失败')
        }
        this.loadStatus()
      }).catch(() => { this.actionLoading = false })
    }
  }
}
</script>

<style scoped>
.train-log {
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 8px 12px;
  font-family: monospace;
  font-size: 12px;
  max-height: 200px;
  overflow: auto;
  white-space: pre-wrap;
}
</style>
